<template>
  <div class="open-pay-container">
    <div class="flex radio-wrap">
      <el-radio-group
        v-model="data.product_type"
        ref="radio"
        :disabled="data.edit"
      >
        <el-radio label="1" :class="{ active: data.product_type === '1' }">
          活动课包
        </el-radio>
        <el-radio label="2" :class="{ active: data.product_type === '2' }">
          标准课程
        </el-radio>
      </el-radio-group>
    </div>
    <div class="gray tips-wrap">
      新学员成功购买小课包/商品，自动录入成为意向学员；购买课程套餐，自动录入成为在读学员
    </div>

    <div class="flex add-wrap">
      <span
        v-if="data.product_type === '1' && data.goods_list.length < 10"
        class="add-product"
        @click="handleAddProduct"
      >
        <span>+ 添加课包</span>
      </span>
      <span
        v-if="data.product_type === '2' && data.combo_list.length < 10"
        class="add-product"
        @click="handleAddProduct"
      >
        <set-dialog
          @on-change="inputSet"
          :max="10"
          :originData="data.combo_list"
        >
          + 添加课程
        </set-dialog>
      </span>
      <span class="gray add-tips">最多可添加10个</span>
    </div>
    <div v-if="data.product_type === '1'" class="activity-course">
      <div
        class="activity-wrap"
        v-for="(item, index) in data.goods_list"
        :key="item.id"
      >
        <div class="flex activity-top">
          <div class="activity-title">活动课包{{ index + 1 }}</div>
          <div class="flex activity-stock">
            <div class="stock-text">库存</div>
            <el-input
              placeholder="请输入库存"
              oninput="if (value.length>9) value=value.slice(0,9)"
              v-model="item.stock"
              type="number"
              @input="handleStockInput(item)"
            ></el-input>
            <el-popover
              placement="top"
              popper-class="followuppopover"
              width="135"
              trigger="hover"
            >
              <p class="tipck">
                库存为选填字段，当填写库存数值，课包库存售卖到库存数值就无法售卖
              </p>
              <div class="question" slot="reference">
                <div>?</div>
              </div>
            </el-popover>
            <span
              class="green activity-delete"
              @click="handleDelProduct(item, index)"
            >
              删除
            </span>
          </div>
        </div>
        <div class="flex product-item">
          <div class="gray product-label">课包名称：</div>
          <div class="product-content">
            <el-input
              placeholder="请输入商品名称"
              v-model="item.name"
            ></el-input>
          </div>
        </div>
        <div class="flex product-item">
          <div class="gray product-label">支付金额：</div>
          <div class="product-content">
            <el-input
              placeholder="请输入支付金额"
              v-model="item.paid_amount"
              type="number"
              oninput="if (value.length>9) value=value.slice(0,9)"
              @input="handleInput(item.paid_amount, index)"
            ></el-input>
          </div>
        </div>
      </div>
    </div>
    <div v-if="data.product_type === '2'" class="standard-course">
      <div
        class="standard-wrap"
        v-for="(set, index) in data.combo_list"
        :key="set.combo_product_id"
      >
        <div class="flex standard-top">
          <div class="standard-title">{{ set.name }}</div>
          <div class="standard-price">套餐总价￥{{ set.price }}</div>
          <div class="flex standard-stock">
            <div class="stock-text">库存</div>
            <el-input
              placeholder="请输入库存"
              oninput="if (value.length>9) value=value.slice(0,9)"
              v-model="set.stock"
              type="number"
              @input="handleStockInput(set)"
            ></el-input>
            <el-popover
              placement="top"
              popper-class="followuppopover"
              width="135"
              trigger="hover"
            >
              <p class="tipck">
                库存为选填字段，当填写库存数值，课程售卖到库存数值就无法售卖
              </p>
              <div class="question" slot="reference">
                <div>?</div>
              </div>
            </el-popover>
            <span
              class="green activity-delete"
              @click="handleDelProduct(set, index)"
            >
              删除
            </span>
          </div>
        </div>
        <div
          class="flex product-item"
          v-for="product in set.item"
          :key="product.product_id"
        >
          <div class="gray product-name">
            {{ product.product_name }}
          </div>
          <div class="gray product-hour">
            {{ Number(product.quantity) }}课时
          </div>
          <div class="gray product-price">
            小计￥{{ Number(product.subtotal) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import setDialog from "./setDialog.vue";
import { setDetail } from "@/api/course";

export default {
  components: {
    setDialog,
  },
  props: ["originData"],
  data() {
    return {
      data: {
        product_type: "1",
        goods_list: [], // 活动课包
        combo_list: [], // 标准课程
        edit: false,
      },
      copy_combo_list: [],
      originIds: [],
    };
  },
  mounted() {
    // console.log("mounted", this.originData);
    if (this.originData && this.originData.product_type > 0) {
      this.originData.goods_list.forEach((item) => {
        // 当 is_open_stock 为 2 时，stock 为 ""
        if (item.is_open_stock === 2) {
          item.stock = "";
        }
      });
      this.originData.combo_list.forEach((item) => {
        // 当 is_open_stock 为 2 时，stock 为 ""
        if (item.is_open_stock === 2) {
          item.stock = "";
        }
      });
      this.data = {
        product_type: String(this.originData.product_type),
        goods_list: this.originData.goods_list,
        combo_list: this.originData.combo_list,
        edit: this.originData.edit,
      };
    }
    // 避免 el-radio 报 aria-hidden 的错误
    this.$refs.radio.$children.forEach((item) => {
      item.$refs.radio.removeAttribute("aria-hidden");
    });
  },
  watch: {
    data: {
      handler() {
        this.$emit("dataChange", this.data);
      },
      deep: true,
    },
  },
  methods: {
    handleAddProduct() {
      if (this.data.product_type === "1") {
        this.data.goods_list.push({
          stock: "",
          good_name: "",
          paid_amount: "",
        });
      }
    },
    handleDelProduct(item, index) {
      if (this.data.product_type === "1") {
        this.$confirm(`确认对活动课包${index + 1}进行删除？`, "删除课包", {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
        })
          .then(() => {
            this.data.goods_list.splice(index, 1);
            this.$message({
              type: "success",
              message: "删除成功",
            });
          })
          .catch(() => {});
      }
      if (this.data.product_type === "2") {
        this.$confirm(`确认对${item.name}进行删除？`, "删除课程", {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
        })
          .then(() => {
            this.data.combo_list.splice(index, 1);
            this.$message({
              type: "success",
              message: "删除成功",
            });
          })
          .catch(() => {});
      }
    },
    inputSet(arr) {
      this.copy_combo_list = [];
      // 获取新数据套餐 id
      let arrIds = arr.map((item) => {
        return item.combo_product_id;
      });
      // 旧数据套餐 id
      if (this.data.combo_list && this.data.combo_list.length > 0) {
        this.originIds = this.data.combo_list.map((item) => {
          return item.combo_product_id;
        });
      }
      // 过滤两者 id 的差集，为获取差集课程的 detial
      let differenceIds = arrIds.filter(
        (item) => !this.originIds.includes(item)
      );
      if (this.data.combo_list && this.data.combo_list.length > 0) {
        this.data.combo_list.forEach((item) => {
          let isSame = arrIds.includes(item.combo_product_id);
          if (isSame) {
            this.copy_combo_list.push(item);
          }
        });
      }
      // differenceIds 有变动，获取课程 detail
      if (differenceIds.length !== 0) {
        differenceIds.forEach((item) => {
          this.handleGetComboDetail(item);
        });
      } else {
        // 只有删除时没变动，不用获取
        this.data.combo_list = this.copy_combo_list;
      }
    },
    handleGetComboDetail(id) {
      setDetail({
        combo_product_id: id,
      }).then((res) => {
        res.data.stock = "";
        this.copy_combo_list.push(res.data);
        this.data.combo_list = this.copy_combo_list;
      });
    },
    handleStockInput(item) {
      if (Number(item.stock) < 0) {
        this.$message({
          message: `${
            Number(this.data.product_type) === 1 ? "课包" : "课程"
          }库存数值需大于或等于0`,
          type: "error",
        });
      } else if (String(item.stock).includes(".")) {
        this.$message({
          message: `${
            Number(this.data.product_type) === 2 ? "课包" : "课程"
          }库存数值必须是整数`,
          type: "error",
        });
      }
    },
    // 输入逻辑控制
    handleInput(val, index) {
      if (Number(val) < 0) {
        this.$message({
          message: "支付金额不能为负数",
          type: "error",
        });
      }
      // 如果有小数，并且小数的位数大于2，将2位之后的数直接截掉
      if (/\.\d{3}/.test(String(val))) {
        this.$message({
          type: "warning",
          message: "请保留两位小数",
        });
        this.data.goods_list[index].paid_amount =
          Math.floor(Number(val) * 100) / 100;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.open-pay-container {
  justify-content: center !important;
  padding: 0 65px 0 45px;
  margin-bottom: 10px;
  /deep/.radio-wrap {
    padding-left: 70px;
    .el-radio {
      margin-right: 100px;
    }
    .active {
      span {
        color: #07d1aa !important;
        font-size: 14px;
      }
    }
  }
  .tips-wrap {
    margin: 15px 0;
    padding: 5px 0;
  }
  .add-wrap {
    .add-product {
      height: 30px;
      width: 82px;
      line-height: 30px;
      text-align: center;
      border: 1px solid rgba(7, 209, 170, 1);
      border-radius: 4px;
      // padding: 7px 11px;
      color: white;
      background: #07d1aa;
      margin-right: 10px;
      cursor: pointer;
    }
  }
  .activity-course {
    .activity-wrap {
      border: 1px solid rgba(225, 229, 233, 1);
      margin: 15px 0;
      .activity-top {
        background: rgba(242, 246, 250, 1);
        justify-content: space-between;
        padding: 6px 26px;
        .activity-title {
          flex: 1;
        }
        /deep/.activity-stock {
          width: 200px;
          .el-input {
            margin: 0 10px;
            width: 80px;
            .el-input__inner {
              height: 28px !important;
              line-height: 28px !important;
              padding: 0 8px !important;
            }
          }
          .activity-delete {
            margin-left: 18px;
            cursor: pointer;
          }
        }
      }
      .product-item {
        margin: 10px 0;
        padding: 0 10px;
        .product-label {
          &::before {
            content: "*";
            color: #f56c6c;
            margin-right: 4px;
          }
        }
        .product-content {
          width: 85%;
        }
      }
    }
  }
  .standard-course {
    .standard-wrap {
      border: 1px solid rgba(225, 229, 233, 1);
      margin: 15px 0;
      .standard-top {
        background: rgba(242, 246, 250, 1);
        justify-content: space-between;
        padding: 6px 26px;
        .standard-title {
          width: 200px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          word-wrap: break-word;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
        /deep/.standard-stock {
          width: 200px;
          .el-input {
            margin: 0 10px;
            width: 80px;
            .el-input__inner {
              height: 28px !important;
              line-height: 28px !important;
              padding: 0 8px !important;
            }
          }
          .activity-delete {
            margin-left: 18px;
            cursor: pointer;
          }
        }
      }
      .product-item {
        margin: 20px 0;
        padding: 0 25px;
        .product-name {
          width: 50%;
        }
        .product-price,
        .product-hour {
          width: 30%;
        }
      }
    }
  }
}

.flex {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.green {
  color: #07d1aa;
}
.gray {
  color: rgba(92, 93, 94, 1);
}
</style>
